<template>
  <section
    class="bg-gray-50 py-8"
  >
    <TContainer>
      <LazyVisibleGeneralNearbyLocations
        hydrate-on-visible
        :locations="locations"
        show-rv-count
        name-display="kindNameWithPreposition"
        kind="RVRentals"
        :title="nearbyDestinationsTitle"
      />
    </TContainer>
  </section>
</template>

<script setup lang="ts">
import type { NearbyLocation } from '~/components/general/nearby-locations/types'
import type { PointOfInterest } from '~/types/rental-api-aliases'

const props = defineProps<{
  destination?: PointOfInterest
  locations: NearbyLocation[]
}>()

const { locale, t } = useI18n()

const nearbyDestinationsTitle = computed(() => {
  const poi = props.destination
  if (!poi) {
    return ''
  }

  return t('nearbyLocationsTitle', {
    locationNearby: pointOfInterestLocationNameWithPreposition({
      locale: locale.value,
      pointOfInterestId: poi.Id,
      name: poi.Name,
      component: poi.Component,
      parentName: typeof poi.ParentAttributes?.Abbreviation === 'string' ? poi.ParentAttributes.Abbreviation : poi.ParentName,
      grammarRules: poi.Attributes?.GrammarRules,
      useNearby: true,
    }),
  })
})
</script>

<i18n lang="json">
  {
    "en": {
      "nearbyLocationsTitle": "RV rentals {locationNearby}"
    },
    "fr": {
      "nearbyLocationsTitle": "VRs à louer {locationNearby}"
    }
  }
</i18n>
